module.exports = __webpack_public_path__ + "static/media/delete.a398f415.svg";